const LEGACY_DISCOUNT_KEYS = ['Descuento01', 'Descuento02', 'Descuento03']

export const defaultOrderAdjustments = [
    { key: 'Descuento03', label: 'DF', operation: 'subtract', base: 'net', inputType: 'percent', enabled: true },
    { key: 'Descuento02', label: 'DC', operation: 'subtract', base: 'net', inputType: 'percent', enabled: true },
    { key: 'Descuento01', label: 'DPP', operation: 'subtract', base: 'net', inputType: 'percent', enabled: true },
]

export const normalizeOrderAdjustments = (adjustments = []) =>
    adjustments
        .map((adjustment, index) => ({
            key: adjustment.key || LEGACY_DISCOUNT_KEYS[index] || `Ajuste${index + 1}`,
            label: adjustment.label || adjustment.key || `Ajuste ${index + 1}`,
            operation: adjustment.operation === 'add' ? 'add' : 'subtract',
            base: adjustment.base || 'net',
            inputType: adjustment.inputType || 'percent',
            enabled: adjustment.enabled !== false,
        }))
        .filter((adjustment) => adjustment.key)

export const resolveOrderAdjustments = (orderFormConfig = {}) => {
    if (Array.isArray(orderFormConfig.orderAdjustments) && orderFormConfig.orderAdjustments.length > 0) {
        return normalizeOrderAdjustments(orderFormConfig.orderAdjustments)
    }

    if (Array.isArray(orderFormConfig.discounts) && orderFormConfig.discounts.length > 0) {
        return normalizeOrderAdjustments(
            orderFormConfig.discounts.map((discount) => ({
                ...discount,
                operation: 'subtract',
                base: 'net',
                inputType: 'percent',
            }))
        )
    }

    return normalizeOrderAdjustments(defaultOrderAdjustments)
}

export const getAdjustmentValue = (orderInfo, adjustment) => {
    const rawValue = orderInfo?.[adjustment.key]
    const parsed = Number(rawValue)
    return Number.isFinite(parsed) ? parsed : 0
}

export const getAdjustmentBaseAmount = (adjustment, amounts = {}) => {
    switch (adjustment.base) {
    case 'product':
        return amounts.productBaseTotal || 0
    case 'subtotal':
        return amounts.subtotalBeforeAdjustments || 0
    case 'total':
        return amounts.totalBeforeAdjustments || 0
    case 'net':
    default:
        return amounts.net || 0
    }
}

export const getAdjustmentAmount = (orderInfo, adjustment, amounts = {}) => {
    const value = getAdjustmentValue(orderInfo, adjustment)

    if (adjustment.base === 'product' && Array.isArray(amounts.productLines)) {
        if (adjustment.inputType === 'amount') {
            return Number(amounts.productLines.reduce(
                (acc, line) => acc + ((Number(line.quantity) || 0) * value),
                0
            ).toFixed(2))
        }

        return Number(amounts.productLines.reduce((acc, line) => {
            const lineBase = Number(line.baseAmount) || 0
            return acc + ((lineBase * value) / 100)
        }, 0).toFixed(2))
    }

    const baseAmount = getAdjustmentBaseAmount(adjustment, amounts)

    if (adjustment.inputType === 'amount') {
        return value
    }

    return Number(((baseAmount * value) / 100).toFixed(2))
}

export const getEnabledOrderAdjustments = (orderFormConfig = {}) =>
    resolveOrderAdjustments(orderFormConfig).filter((adjustment) => adjustment.enabled)
